
import http from '@/utils/http'
import Layout from '@/views/layout/Layout'

export function getMenus() {
  return http({
    url: '/api/sys/menus',
    method: 'get',
    params: {"where": {}, "page": "[0,999999999]"}
  })
}

 export function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@/views/system/loading.vue').default,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@/views/system/timeout.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 200,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000
  });
  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children);
    }
  });
}

export function getJsonTree(data, parentid) {
  var itemArr = [];
  for (var i = 0; i < data.length; i++) {
    var node = data[i];
    if (node.parentid === parentid) {
      var newNode = {};
      newNode.id = node.id;
      newNode.label = node.menuname;
      newNode.parentid = node.parentid;
      newNode.path = node.pagehref;

      let jsoncache = node.jsoncache === undefined || node.jsoncache === '' ? {} : JSON.parse(node.jsoncache);
      //  if (jsoncache.component!=undefined && jsoncache.component!=""){
      //   newNode.component = () => import(jsoncache.component)
      // }else{
      //   newNode.component = Layout;
      // }
      newNode.meta = {title: node.menuname, icon: jsoncache.icon === undefined || jsoncache.icon === '' ? 'user' : jsoncache.icon}
      newNode.children = getJsonTree(data, node.id);
      itemArr.push(newNode);
    }
  }
  // console.log('getJsonTree')
  return itemArr;
}
//
// export function getJsonTree(data, parentid) {
//   var itemArr = [];
//   for (var i = 0; i < data.length; i++) {
//     var node = data[i];
//     if (node.parentid == parentid) {
//       var newNode = {};
//       newNode.id = node.id;
//       newNode.label = node.name;
//       newNode.parentid = node.parentid;
//       newNode.path = node.pagehref;
//
//       let jsoncache = JSON.parse(node.jsoncache)
//       console.log(node.name+','+node.id+','+node.parentid);
//       if (jsoncache.component!=undefined && jsoncache.component!=""){
//         newNode.component = () => import(jsoncache.component)
//       }else{
//         newNode.component = Layout;
//       }
//       newNode.meta = {title:node.name,icon:jsoncache.icon==undefined || jsoncache.icon==''? 'user':jsoncache.icon}
//       newNode.children = getJsonTree(data, node.id);
//       itemArr.push(newNode);
//     }
//   }
//   return itemArr;
// }



// WEBPACK FOOTER //
// ./src/api/base/menu.js